
import { ApiError } from '@ms/utilities-error/lib/ApiError';
import { IQosEndSchema, ResultTypeEnum } from '../events/Qos.event';

/**
 * @public
 */
export function getQosEndSchemaFromError(error: Error | undefined): IQosEndSchema {
  return {
    resultType: error ?
      ResultTypeEnum.Failure :
      ResultTypeEnum.Success,
    error: error && error.message,
    resultCode: error && error.name || 'Unknown',
    ...(error instanceof ApiError ? {
      resultCode: error.code,
      resultType: error.isExpected ?
        ResultTypeEnum.ExpectedFailure :
        ResultTypeEnum.Failure
    } : {}),
    extraData: {
      ...(error instanceof ApiError ? {
        correlationId: error.correlationId
      } : {})
    }
  };
}
